import React from 'react';
import { Box } from '@mui/material';

// Shared retro-styled close (✕) button used by every popup/section on the
// homepage (menu, dashboard, payments, auth) so the control looks identical
// everywhere, stays above surrounding elements, and keeps a large tap target
const RetroCloseButton = ({ onClick, label = 'Close', sx = {} }) => (
  <Box
    onClick={onClick}
    role="button"
    tabIndex={0}
    aria-label={label}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    }}
    sx={{
      // Plain ✕ matching the game dashboards' close buttons. NOTE: not
      // Press Start 2P — that font has no ✕ glyph, so the browser fell back
      // to another font inside the old boxed frame, which rendered uneven.
      position: 'absolute',
      top: 6,
      right: 6,
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#FFFFFF',
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      fontFamily: "'Roboto', Arial, sans-serif",
      fontSize: '1.5rem',
      lineHeight: 1,
      userSelect: 'none',
      zIndex: 20,
      transition: 'color 0.15s ease, transform 0.15s ease',
      '&:hover': {
        color: '#00BFFF',
      },
      '&:active': {
        transform: 'scale(0.92)',
      },
      ...sx,
    }}
  >
    ✕
  </Box>
);

export default RetroCloseButton;
